import { StackClientApp } from '@stackframe/js';

export const stackClientApp = new StackClientApp({
  baseUrl: process.env.REACT_APP_STACK_API_URL,
  projectId: process.env.REACT_APP_STACK_PROJECT_ID,
  publishableClientKey: process.env.REACT_APP_STACK_PUBLISHABLE_CLIENT_KEY,
  tokenStore: 'cookie',
  urls: {
    oauthCallback: window.location.origin + '/auth/callback',
  },
});
